var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"lottie",rawName:"v-lottie"}],staticClass:"lottie-container"})}
var staticRenderFns = []

export { render, staticRenderFns }